module.exports = __webpack_public_path__ + "img/mz.f6d717c4.svg";